import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import WithOverlay from "../../popups/withOverlayHoc";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";


const LookNotCompatiblePopup = (props) => {

  const {lookActiveFeature, lookOverlayOpened, setLookOverlayOpened, updateCanvasCount} = props;

  const stylePopups = [LOOK_OVERLAYS.notCompatiblePopup];
  if (!lookOverlayOpened || !stylePopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const closePopup = (hideOverlay) => {
    hideOverlay(() => {
      setLookOverlayOpened("");
    })
  }

  const updateDesignButtonClick = (hideOverlay) => {
    if (lookActiveFeature) { // just in case
      lookActiveFeature.applyFeatureIfNotCompatible(); // first set new rules for this feature
      lookActiveFeature.handleClick(); // change item
      updateCanvasCount()
    }
    closePopup(hideOverlay);  // then remove the view
  }

  return (
    <WithOverlay className="look-overlay--style">
      {(hideOverlay) => (
        <div className="look-popup look-popup--question">
          <div className="look-popup__content">
            <h2 className="h2 h2--regular text-left">
              <FormattedMessage id={"look.notCompatible.title"}/>
            </h2>
            <p className="text text-left">
              <FormattedMessage id={"look.notCompatible.text"}/>
            </p>
          </div>
          <div className={"look-popup__buttons"}>
            <Button className={"look-button look-button--secondary look-button--min"}
                    onClick={() => closePopup(hideOverlay)}>
              <FormattedMessage id="buttons.cancel"/>
            </Button>
            <Button className={"look-button look-button--primary look-button--min"}
                    onClick={() => updateDesignButtonClick(hideOverlay)}>
              <FormattedMessage id={"look.notCompatible.updateDesignButton"}/>
            </Button>
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookOverlayOpened} = store.lookState;
  return {
    lookActiveFeature,
    lookOverlayOpened,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  updateCanvasCount,
}

export default connect(mapStateToProps, mapDispatchToProps)(LookNotCompatiblePopup);
